import axios from "axios";
import { idText } from "typescript";
import { getToken, getUser } from "../Utils/Common";
import { getWithParamsAPICall, postAPICall } from "./axiosMethodCalls";
import { UsePostRequest } from "../hooks/UsePostApiCall";


/***************************
 * LOGIN
 ***************************/

//GET
export const loginUser = async (username, password, terminal) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "login/index",
            {
                username: username,
                password: password,
                terminal: 1
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const loginAuthorize = async (username, password) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "authenticate/index",
            {
                username: username,
                password: password,
                terminal: "1",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

/***************************
 * LOGOUT
 ***************************/

export const logoutUser = async () => {
    
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "logout/index/" + getUser(),
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const resyncData = async () => {
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "online/sync",
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const recordUserActivityLog = async (activity) => {
    try {
        const payload = {
            requester: getUser(),
            activity: activity,
        }
        const response = await UsePostRequest("users/activity_logs", payload, false,)
    } catch (error) {
        console.log(error)
    }
}